import {
  COUNTY_SCALE,
  DISTRICT_ENGLISH_UNITARY,
  DISTRICT_METRO,
  DISTRICT_NON_METRO,
  DISTRICT_SCALE,
  POSTAL_TOWN_SCALE,
  REGION_SCALE,
} from "./geographical_scales"
import {
  HOME_URL,
  generateGeoPathData,
  geoAreaLocationProviderDirectoryPath,
  geoBreakdownDirectoryPath,
} from "./paths"

const generateBreadcrumbLink = (
  geographicScale,
  locationName,
  careType = null,
  districtType = null,
  text = null,
  careServiceType = null,
) => ({
  path: geoAreaLocationProviderDirectoryPath(
    generateGeoPathData(geographicScale, locationName, careType, districtType),
    careServiceType,
  ),
  text: text || locationName,
})

const breadcrumbCopyForPageType = (pageType) => {
  switch (pageType) {
    case "home_care":
      return "Home care agencies"
    case "care_home":
      return "Care homes"
    case "dementia":
      return "Dementia care homes"
    default:
      return null
  }
}

const regionBreadcrumb = (branchRecord) =>
  branchRecord.address.region === "London"
    ? generateBreadcrumbLink(REGION_SCALE, branchRecord.address.region)
    : null

const countyBreadcrumb = (branchRecord) =>
  branchRecord.address.county
    ? generateBreadcrumbLink(COUNTY_SCALE, branchRecord.address.county)
    : null

const districtBreadcrumb = (branchRecord) =>
  branchRecord.address.district
    ? generateBreadcrumbLink(
        DISTRICT_SCALE,
        branchRecord.address.district,
        null,
        branchRecord.address.districtType,
      )
    : null

const postalTownBreadcrumb = (
  branchRecord,
  careType = null,
  careServiceType = null,
) => {
  const pageType = careServiceType || careType
  const text = breadcrumbCopyForPageType(pageType)
  return generateBreadcrumbLink(
    POSTAL_TOWN_SCALE,
    branchRecord.address.city,
    careType,
    null,
    text,
    careServiceType,
  )
}

const pageTypeBreadcrumb = (
  geoPathData,
  branchRecord,
  careType,
  careServiceType = null,
) => {
  const pageType = careServiceType || careType

  return generateBreadcrumbLink(
    geoPathData.geographicScale,
    geoPathData.locationName,
    careType,
    branchRecord.address.districtType,
    breadcrumbCopyForPageType(pageType),
    careServiceType,
  )
}

// eslint-disable-next-line import/prefer-default-export
export const breadcrumbLinksForGeoLocation = (
  geoPathData,
  branchRecord,
  careServiceType,
) => [
  { path: HOME_URL, text: "Home" },
  { path: geoBreakdownDirectoryPath(), text: "Locations" },
  regionBreadcrumb(branchRecord),
  [DISTRICT_METRO, DISTRICT_NON_METRO, DISTRICT_ENGLISH_UNITARY].includes(
    branchRecord.address.districtType,
  )
    ? countyBreadcrumb(branchRecord)
    : null,
  [DISTRICT_SCALE, POSTAL_TOWN_SCALE].includes(geoPathData.geographicScale)
    ? districtBreadcrumb(branchRecord)
    : null,
  geoPathData.geographicScale === POSTAL_TOWN_SCALE
    ? postalTownBreadcrumb(branchRecord)
    : null,
  geoPathData.careType && !careServiceType
    ? postalTownBreadcrumb(branchRecord, geoPathData.careType)
    : null,
  geoPathData.careType && careServiceType
    ? pageTypeBreadcrumb(geoPathData, branchRecord, geoPathData.careType)
    : null,
  careServiceType
    ? pageTypeBreadcrumb(
        geoPathData,
        branchRecord,
        geoPathData.careType,
        careServiceType,
      )
    : null,
]
